/* eslint-disable */
function Cards(props) {
    const { item, style, handleDragStart, handleClick } = props;
    return (
        <div style={style} className='p-2'>
            <div className='bg-white rounded-xl shadow-sm p-3 flex flex-col items-center hover:shadow-md transition'
                draggable
                onDragStart={(e) => handleDragStart(e, item)}
                onClick={() => handleClick(item)}
            >
                <img
                    src={item?.productImageUrl}
                    alt={item?.productName}
                    className='w-full h-24 object-cover rounded-md'
                />
                <p className='mt-2 text-sm font-medium text-gray-800 text-center'>
                    {item?.productName}
                </p>
            </div>
        </div>
    )
}
export default Cards;